import { h } from 'vue'
import { useStateStore } from '@json-render/vue'
import { z } from 'zod'

import EventsDirectorySection from '../components/organisms/EventsDirectorySection.vue'

const resourceStateSchema = z.enum(['loading', 'empty', 'error', 'ready'])
const eventCardSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    imageUrl: z.string(),
    dateLabel: z.string(),
    locationLabel: z.string(),
    attendanceLabel: z.string().optional(),
    description: z.string().optional(),
    status: z.enum(['live', 'registered', 'upcoming', 'recording', 'past']).optional(),
    isLive: z.boolean().optional(),
    isRegistered: z.boolean().optional(),
    imageFocalPoint: z.object({ x: z.number(), y: z.number() }).strict().optional(),
    timeLabel: z.string().optional(),
    dateChip: z.string().optional(),
    startAt: z.string().optional(),
    endAt: z.string().optional(),
    timeZone: z.string().optional(),
  })
  .strict()

const directoryProps = z
  .object({
    state: resourceStateSchema,
    events: z.array(eventCardSchema),
    hasNextPage: z.boolean().optional(),
    isFetchingNextPage: z.boolean().optional(),
    isSearchActive: z.boolean().optional(),
    itemLimit: z.number().optional(),
    density: z.enum(['compact', 'comfortable', 'roomy']).optional(),
  })
  .strict()

export const EVENTS_DIRECTORY_EXPERIENCE_COMPONENT_DEFINITIONS = {
  EventsDirectory: {
    props: directoryProps,
    description: 'Full live, upcoming, or past event grid.',
  },
} as const

interface RegistryContext<Props> {
  readonly props: Props
  readonly emit: (event: string) => void
}

export const EVENTS_DIRECTORY_EXPERIENCE_COMPONENTS = {
  EventsDirectory: ({
    props,
    emit,
  }: RegistryContext<z.infer<(typeof EVENTS_DIRECTORY_EXPERIENCE_COMPONENT_DEFINITIONS)['EventsDirectory']['props']>>) => {
    const { set } = useStateStore()
    return h(EventsDirectorySection, {
      state: props.state,
      events: props.events,
      hasNextPage: props.hasNextPage,
      isFetchingNextPage: props.isFetchingNextPage,
      isSearchActive: props.isSearchActive,
      itemLimit: props.itemLimit,
      density: props.density,
      onOpenEvent: (eventId: string) => {
        set('/ui/selectedEventId', eventId)
        emit('openEvent')
      },
      onLoadMore: () => emit('loadMore'),
    })
  },
} as const
